<template>
  <div class="mt-3">
    <v-row dense>
      <v-col cols="12" sm="4">
        <px-autocomplete-cadastro-adicional
          type="ARMAZEM"
          :dense="dense"
          label="Armazém"
          class="required rounded-tag-small"
          v-model="formData.armazem"/>
      </v-col>
      <v-col cols="12" sm="4">
        <px-autocomplete-cadastro-adicional
          :dense="dense"
          type="CONTA_CONTABIL"
          label="Conta"
          class="required rounded-tag-small"
          v-model="formData.contaContabil"/>
      </v-col>
      <v-col cols="12" sm="4">
        <px-autocomplete-cadastro-adicional
          :dense="dense"
          init-search
          type="CONTA_FINANCEIRA"
          label="Classe de valor"
          class="required rounded-tag-small"
          v-model="formData.contaFinanceira"/>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  props: {
    formData: {
      type: Object,
      required: true,
    },
    dense: {
      type: Boolean,
      default: false,
    },
    singleLine: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
